import debug from "debug";

export default debug("jp:api");
